module.exports = __webpack_public_path__ + "static/001.cb3ede80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image/001.jpg
// module id = 1218
// module chunks = 35783957827783